import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

const STEP_HEIGHT = 8
const BORDER_RADIUS = 8

export const Container = styled.div`
  height: ${STEP_HEIGHT}px;
  width: 100%;
  background-color: ${themeGet('colors.alto')};
  overflow: hidden;
  position: relative;
  border-radius: ${BORDER_RADIUS}px;
`

export const StepDone = styled.div`
  height: ${STEP_HEIGHT}px;
  background-color: ${themeGet('colors.secondary')};
  overflow: hidden;
  border-radius: ${BORDER_RADIUS}px;

  width: ${({ total, current }) => (100 / total) * current}%;
`

export const StepCurrent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: ${({ total, current }) => (100 / total) * (current - 1)}%;
  background-color: ${themeGet('colors.secondary')};
`
